<template>
  <v-col cols="12" md="6">
    <v-card-subtitle class="mx-auto pt-md-0">
      <v-icon left>{{ handsIcon }}</v-icon>
      <span
        class="font-weight-bold">{{ $vuetify.lang.t('$vuetify.map.driverSettings.tabs.handsFrame') }}</span>
    </v-card-subtitle>
    <v-row class="mx-auto ml-5 mt-n3" no-gutters justify="start">
      <v-col cols="12" md="6">
        <div class="d-inline-flex">
          <v-checkbox v-show="isFilter" class="mt-n1 align-end" dense
                      @change="filterValueChanged($event, 'faceIntersection')"
                      hide-details v-model="filters.faceIntersection"></v-checkbox>
          <v-switch
            :label="$vuetify.lang.t(`$vuetify.criticalDataset.${CriticalDatasetLabels.DETECTORS}.faceIntersection`)"
            :disabled="isFilter && !filters.faceIntersection"
            v-model="handsFrameEntry.faceIntersection" hide-details></v-switch>
        </div>
      </v-col>
      <!--          <v-col cols="12" md="4">-->
      <!--            <v-switch-->
      <!--              :label="$vuetify.lang.t(`$vuetify.criticalDataset.${CriticalDatasetLabels.DETECTORS}.beltIntersection`)"-->
      <!--              v-model="handsFrameEntry.beltIntersection" hide-details></v-switch>-->
      <!--          </v-col>-->
      <v-col cols="12" md="6">
        <div class="d-inline-flex">
          <v-checkbox v-show="isFilter" class="mt-n1 align-end" dense
                      @change="filterValueChanged($event, 'holdedObject')"
                      hide-details v-model="filters.holdedObject"></v-checkbox>
          <v-switch
            :label="$vuetify.lang.t(`$vuetify.criticalDataset.${CriticalDatasetLabels.DETECTORS}.holdedObject`)"
            :disabled="isFilter && !filters.holdedObject"
            v-model="handsFrameEntry.holdedObject" hide-details></v-switch>
        </div>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { CriticalDatasetLabels } from '../../../enum'
import criticalDatasetMixin from '../../../mixins/criticalDatasetMixin'
import { DetectorFrameHands } from '../../../models/criticalDataset/DetectorFrameHands'
import { mdiHandRight } from '@mdi/js'

export default {
  name: 'criticalDatasetHandsFrameDetector',
  mixins: [criticalDatasetMixin(DetectorFrameHands, 'handFrame')],
  props: {
    handsFrameEntry: DetectorFrameHands
  },
  data: () => ({
    handsIcon: mdiHandRight
  }),
  created () {
    this['CriticalDatasetLabels'] = CriticalDatasetLabels
  }
}
</script>

<style scoped>

</style>
